import React from 'react';
import ENC_logo from '../../ui-kit/AppLayout/assets/ENC_Logo_silver.png';
import JINGLE_logo from '../../ui-kit/AppLayout/assets/Jingle_Logo_lg.png';
import LVS_logo from '../../ui-kit/AppLayout/assets/LVS_Logo.png';
import {LogoSectionWrapper} from './styles';
import {themes} from '../../ui-kit/theme/theme';
import {THEME} from '../../constants/env';

const LogoMap = {
  [themes.enchant]: ENC_logo,
  [themes.coke]: '',
  [themes.lite]: JINGLE_logo,
  [themes.lvs]: LVS_logo,
};

export const LogoSection: React.FC = () => {
  return <LogoSectionWrapper>{LogoMap?.[THEME] && <img src={LogoMap[THEME]} />}</LogoSectionWrapper>;
};
